import { render, staticRenderFns } from "./PositionAccess.vue?vue&type=template&id=06f88510"
import script from "./PositionAccess.vue?vue&type=script&lang=js"
export * from "./PositionAccess.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/_access-management.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports